<script lang="ts" context="module">
    import Authenticate from "./Authenticate.svelte"
    import { writable } from "svelte/store"
    import { openBottomPopup, closeBottomPopup } from "@components/bottomPopup/bottomPopup.module"
    export const registerView = writable(false)
    const privacyPolicy = writable(false)
    export function viewPrivacyPolicy() {
        privacyPolicy.set(true)
    }

    export function openAuth(register?: boolean, settings: Record<string, unknown> = {}) {
        if (register !== undefined && register !== null) {
            registerView.set(register)
        }
        openBottomPopup(Authenticate, settings)
    }
</script>

<script lang="ts">
    import Login from "@components/forms/Login.svelte"
    import Register from "@components/forms/Register.svelte"
    import { userStatus, verifyEmail } from "@utils/underhood/firebase"
    import PrivacyPolicy from "@components/PrivacyPolicy.svelte"
    import { onDestroy } from "svelte"
    import { clickEnter } from "@utils/directives/accessibility"
    import Button from "@components/button/Button.svelte"

    $: if ($userStatus != "out") closeBottomPopup()
    let verificationSent = false

    onDestroy(() => {
        $privacyPolicy = false
    })
</script>

{#if $privacyPolicy}
    <div class="privacyWrapper">
        <PrivacyPolicy />
        <Button color="purple" go={() => ($privacyPolicy = false)}>Back</Button>
    </div>
{/if}
<div class="auth-panel" class:hidden={$privacyPolicy}>
    {#if $userStatus == "unverified"}
        <h2>Verify your email</h2>
        <form class="form" on:submit|preventDefault>
            <Button
                color="purple"
                disabled={verificationSent}
                go={() => {
                    verifyEmail().finally(() => (verificationSent = true))
                }}>Resend email</Button
            >
        </form>
    {:else if !$registerView}
        <div>
            <h2>Log in</h2>
            <p>Log in below to start using all the features of the app.</p>

            <Login />

            <p class="auth-switch">
                Don’t have an account? <button
                    class="auth-link"
                    on:keydown={clickEnter}
                    type="button"
                    on:click={() => ($registerView = true)}>Create account</button
                >
            </p>
        </div>
    {:else}
        <div>
            <h2>Create an account</h2>
            <p>Enter your information below to start using all the features of the app.</p>

            <Register />
            <p class="auth-switch">
                Already registered? <button
                    class="auth-link"
                    on:keydown={clickEnter}
                    type="button"
                    on:click={() => ($registerView = false)}>Log in</button
                >
            </p>
        </div>
    {/if}
</div>

<style>
    .auth-panel {
        text-align: center;
    }

    .auth-panel.hidden {
        opacity: 0;
        pointer-events: none;
        position: absolute;
    }

    h2,
    p {
        margin: 0;
        text-align: center;
    }

    h2 {
        color: var(--color-grey-900);
        font-family: Lora, ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
        font-size: 1.65rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 1.25;
    }

    p {
        margin-top: 0.65rem;
        color: var(--color-grey-600);
        font-size: 1rem;
        line-height: 1.6;
    }

    .auth-switch {
        margin-top: 1.5rem;
    }

    .auth-link {
        appearance: none;
        border: 0;
        background: transparent;
        color: var(--color-purple-700);
        cursor: pointer;
        font: inherit;
        font-weight: 700;
        padding: 0;
        text-decoration: underline;
        text-decoration-thickness: 0.08em;
        text-underline-offset: 0.16em;
    }

    .auth-link:hover {
        color: var(--color-purple-800);
    }

    .auth-link:focus-visible {
        border-radius: 0.2rem;
        outline: 2px solid var(--color-gold-400);
        outline-offset: 2px;
    }

    .auth-panel :global(.auth-form) {
        margin-top: 1.25rem;
    }

    :global(.darkmode) h2 {
        color: var(--color-grey-50);
    }

    :global(.darkmode) p {
        color: var(--color-grey-200);
    }

    :global(.darkmode) .auth-link {
        color: var(--color-purple-200);
    }

    :global(.darkmode) .auth-link:hover {
        color: var(--color-purple-100);
    }
</style>
